// extracted by mini-css-extract-plugin
export default {"content":"ProfileContent_content__MxWmc"};